<template>
  <nav class="rd-nav" :class="{ 'rd-nav--dense': dense }" :aria-label="label">
    <div ref="scroller" class="rd-nav__groups">
      <div
        v-for="group in groups"
        :key="group.key"
        class="rd-nav__group"
        role="group"
        :aria-label="group.title"
      >
        <span v-if="group.title" class="rd-nav__title">{{ group.title }}</span>
        <div class="rd-nav__tabs">
          <button
            v-for="item in group.items"
            :key="item.key"
            type="button"
            class="rd-nav__tab"
            :class="{ 'is-active': item.key === current }"
            :aria-current="item.key === current ? 'page' : null"
            :title="item.title"
            :data-key="item.key"
            @click="$emit('select', item.key)"
          >
            <v-icon size="18" class="rd-nav__icon">{{ item.icon }}</v-icon>
            <span class="rd-nav__label">{{ item.title }}</span>
            <span
              v-if="item.badge"
              class="rd-nav__badge"
              :class="{ 'is-complete': item.badgeComplete }"
            >
              {{ item.badge }}
            </span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="$slots.tools" class="rd-nav__tools">
      <slot name="tools"></slot>
    </div>
  </nav>
</template>

<script>
const DENSE_FROM = 8;

/**
 * Gornja navigacija izveštaja: grupe sa karticama izveštaja (naziv grupe iznad, značka sa brojačem
 * desno od naziva). Zamenjuje bočni meni, da uz meni aplikacije ne stoje dva bočna menija.
 * Ne zna ništa o podacima: dobija grupe i trenutni izveštaj, javlja izbor.
 * Na uskom ekranu se kartice pomeraju u jednom redu, a izabrana se dovodi u vidno polje.
 */
export default {
  name: "ReportNav",
  props: {
    /** [{ key, title, items: [{ key, title, icon, badge?, badgeComplete? }] }] */
    groups: {
      type: Array,
      default: () => [],
    },
    current: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    /** Mnogo kartica (npr. 12 za admina): bez ikona i uže, da stanu u jedan red. */
    dense() {
      return this.groups.reduce((sum, group) => sum + group.items.length, 0) > DENSE_FROM;
    },
  },
  watch: {
    current() {
      this.$nextTick(this.revealCurrent);
    },
  },
  mounted() {
    this.$nextTick(this.revealCurrent);
  },
  methods: {
    /** Pomera traku (samo vodoravno, bez skrola stranice) tako da je izabrana kartica na sredini. */
    revealCurrent() {
      const scroller = this.$refs.scroller;
      const tab = scroller && scroller.querySelector(".is-active");
      if (!scroller || !tab || scroller.scrollWidth <= scroller.clientWidth) {
        return;
      }
      scroller.scrollLeft = Math.max(0, tab.offsetLeft - (scroller.clientWidth - tab.offsetWidth) / 2);
    },
  },
};
</script>
